import { render, staticRenderFns } from "./ProteinDetail.vue?vue&type=template&id=a54f72b4&scoped=true"
import script from "./ProteinDetail.vue?vue&type=script&lang=js"
export * from "./ProteinDetail.vue?vue&type=script&lang=js"
import style0 from "./ProteinDetail.vue?vue&type=style&index=0&id=a54f72b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54f72b4",
  null
  
)

export default component.exports